import type { BackToSchool2026Phase2Variant } from '~/features/promotions/constants/back-to-school-2026-phase-2-sale';
import {
  getBts2026Phase2SlideKey,
  getBts2026Phase2Variant,
  resolveBts2026Phase2Variant,
} from '~/features/promotions/utils/get-back-to-school-2026-phase-2-variant';

import type { PromoCampaignSurfaceRenderers } from '../types';

export const BACK_TO_SCHOOL_2026_PHASE_2_CAMPAIGN_ID = 'back-to-school-2026-phase-2';

/**
 * Phase 2 gates only on its own `bts50-p2` / `bts10-p2` IDs, so it can sit in `PROMO_CAMPAIGNS`
 * alongside phase 1 without either phase matching the other's promotion.
 *
 * `replacesEvergreenKeys` is deliberately omitted. Phase 1 suppresses the evergreen Master's-in-AI
 * card because every phase 1 slide sold that degree; phase 2 is a sitewide sale spanning courses,
 * MS, and MBA, so the evergreen Master's card should keep rendering beside the promo slide.
 */
export const backToSchool2026Phase2CampaignCore: Pick<
  PromoCampaignSurfaceRenderers<BackToSchool2026Phase2Variant>,
  'id' | 'getSlideKey' | 'matches' | 'isGateReady' | 'resolve'
> = {
  id: BACK_TO_SCHOOL_2026_PHASE_2_CAMPAIGN_ID,
  getSlideKey: ({ resolved }) => getBts2026Phase2SlideKey(resolved),
  matches: ({ forcedPromotionId, promotionId }) =>
    getBts2026Phase2Variant(forcedPromotionId) != null || getBts2026Phase2Variant(promotionId) != null,
  isGateReady: ({ forcedPromotionId, promotionFetched }) =>
    getBts2026Phase2Variant(forcedPromotionId) != null || promotionFetched,
  resolve: ({ forcedPromotionId, promotionId }) => resolveBts2026Phase2Variant(forcedPromotionId, promotionId),
};
